import { ButtonVariant } from '@/shared/components/Buttons';
import type { UpdateStatusDialogProps } from '@/epics/adminManagment/pages/adminList/UpdateStatusDialog';
import { AdminStatusSwitchIcon } from '@/epics/adminManagment/pages/adminList/AdminStatusDialogContent';
import { SERVICE_TYPE_LABELS } from '../../constants/labels';

export type ServiceTypeStatusDialogConfig = Pick<
  UpdateStatusDialogProps,
  | 'title'
  | 'content'
  | 'confirmButtonLabel'
  | 'confirmButtonLabelLoading'
  | 'icon'
  | 'confirmButtonVariant'
>;

export function getServiceTypeStatusDialogConfig(
  serviceTypeName: string,
  isActive: boolean
): ServiceTypeStatusDialogConfig {
  const isActivating = !isActive;

  return {
    title: isActivating
      ? SERVICE_TYPE_LABELS.STATUS_DIALOG_ACTIVATE_TITLE
      : SERVICE_TYPE_LABELS.STATUS_DIALOG_DEACTIVATE_TITLE,
    content: isActivating ? (
      <>
        <span>{SERVICE_TYPE_LABELS.STATUS_DIALOG_ACTIVATE_PREFIX}</span>
        <span className="font-medium">{serviceTypeName}</span>
        <span>{SERVICE_TYPE_LABELS.STATUS_DIALOG_ACTIVATE_SUFFIX}</span>
      </>
    ) : (
      <>
        <span>{SERVICE_TYPE_LABELS.STATUS_DIALOG_DEACTIVATE_PREFIX}</span>
        <span className="font-medium">{serviceTypeName}</span>
        <span>{SERVICE_TYPE_LABELS.STATUS_DIALOG_DEACTIVATE_SUFFIX}</span>
      </>
    ),
    confirmButtonLabel: isActivating
      ? SERVICE_TYPE_LABELS.STATUS_DIALOG_CONFIRM_ACTIVATE
      : SERVICE_TYPE_LABELS.STATUS_DIALOG_CONFIRM_DEACTIVATE,
    confirmButtonLabelLoading: isActivating
      ? SERVICE_TYPE_LABELS.STATUS_DIALOG_CONFIRM_ACTIVATING
      : SERVICE_TYPE_LABELS.STATUS_DIALOG_CONFIRM_DEACTIVATING,
    icon: <AdminStatusSwitchIcon isActivating={isActivating} />,
    confirmButtonVariant: isActivating
      ? ButtonVariant.Success
      : ButtonVariant.Error,
  };
}
